/* @generated */
/* prettier-ignore */
/* eslint-disable */

import React from 'react'
import SVG, { Props } from "react-inlinesvg";

import arrow_down_fat from "@assets/ui/icons/arrow_down_fat.svg";
import arrow_left from "@assets/ui/icons/arrow_left.svg";
import arrow_up_fat from "@assets/ui/icons/arrow_up_fat.svg";
import chevron_down from "@assets/ui/icons/chevron_down.svg";
import chevron_left from "@assets/ui/icons/chevron_left.svg";
import chevron_right from "@assets/ui/icons/chevron_right.svg";
import chevron_up from "@assets/ui/icons/chevron_up.svg";
import circle_filled from "@assets/ui/icons/circle_filled.svg";
import close from "@assets/ui/icons/close.svg";
import config from "@assets/ui/icons/config.svg";
import exclamation from "@assets/ui/icons/exclamation.svg";
import ff from "@assets/ui/icons/ff.svg";
import fleet from "@assets/ui/icons/fleet.svg";
import fullscreen from "@assets/ui/icons/fullscreen.svg";
import heart from "@assets/ui/icons/heart.svg";
import journal from "@assets/ui/icons/journal.svg";
import location from "@assets/ui/icons/location.svg";
import lock from "@assets/ui/icons/lock.svg";
import ok from "@assets/ui/icons/ok.svg";
import pause from "@assets/ui/icons/pause.svg";
import play from "@assets/ui/icons/play.svg";
import plus from "@assets/ui/icons/plus.svg";
import question from "@assets/ui/icons/question.svg";
import redo from "@assets/ui/icons/redo.svg";
import smiley from "@assets/ui/icons/smiley.svg";
import smiley_meh from "@assets/ui/icons/smiley_meh.svg";
import smiley_sad from "@assets/ui/icons/smiley_sad.svg";

export const ArrowDownFatIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={arrow_down_fat} />
);
export const ArrowLeftIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={arrow_left} />
);
export const ArrowUpFatIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={arrow_up_fat} />
);
export const ChevronDownIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={chevron_down} />
);
export const ChevronLeftIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={chevron_left} />
);
export const ChevronRightIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={chevron_right} />
);
export const ChevronUpIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={chevron_up} />
);
export const CircleFilledIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={circle_filled} />
);
export const CloseIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={close} />
);
export const ConfigIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={config} />
);
export const ExclamationIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={exclamation} />
);
export const FFIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={ff} />
);
export const FleetIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={fleet} />
);
export const FullscreenIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={fullscreen} />
);
export const HeartIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={heart} />
);
export const JournalIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={journal} />
);
export const LocationIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={location} />
);
export const LockIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={lock} />
);
export const OKIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={ok} />
);
export const PauseIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={pause} />
);
export const PlayIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={play} />
);
export const PlusIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={plus} />
);
export const QuestionIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={question} />
);
export const RedoIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={redo} />
);
export const SmileyIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={smiley} />
);
export const SmileyMehIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={smiley_meh} />
);
export const SmileySadIcon: React.FC<Omit<Props, "src">> = (props) => (
  <SVG {...props} src={smiley_sad} />
);
